export const getNumberFromString = (str: string) => Number(str.replace(/[^0-9.]+/g, ''));
